import React, { createContext, useState } from "react";
import PropTypes from "prop-types";
import { roleListApi } from "Apis/admin";

export const AdminContext = createContext();

export const AdminContextProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  const [formIsEdit, setFormIsEdit] = useState(false);
  const [editData, setEditData] = useState([]);
  const [rolesList, setRolesList] = useState([]);

  const getRoleApi = async (id) => {
    let response = await roleListApi(id);
    if (response?.status === 200) {
      setRolesList(
        response.data.data.rows?.map((item) => ({
          label: item?.name,
          value: item?.id,
        }))
      );
    }
  };

  const handleOpenModal = () => {
    setOpen(true);
    setFormIsEdit(false);
  };

  return (
    <AdminContext.Provider
      value={{
        open,
        setOpen,
        formIsEdit,
        setFormIsEdit,
        handleOpenModal,
        editData,
        setEditData,
        rolesList,
        setRolesList,
        getRoleApi,
      }}
    >
      {children}
    </AdminContext.Provider>
  );
};

export default AdminContextProvider;
AdminContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
